import { useEffect, useState } from "react";
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Select,
  useToast,
  InputGroup,
  InputRightAddon,
  Flex,
  Text,
  Grid,
  InputLeftAddon,
  Icon,
} from "@chakra-ui/react";
import { FaRegEye, FaUser } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { fetchRoles } from "../../actions/role.actions";
import {
  fetchUserDetailsById,
  updateUserDetailsById,
} from "../../actions/users.action";
import { useParams } from "react-router-dom";
import { Unauthorized } from "../../components/Unauthorized";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";

const EditUser = () => {
  const toast = useToast();
  const { id } = useParams();
  const [roles, setRoles] = useState();
  const [show, setShow] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: "",
    role: "",
  });
  const genders = [
    { id: 1, Name: "Male" },
    { id: 2, Name: "Female" }
  ]

  const getAllRoles = async () => {
    setLoading(true);
    try {
      let data = await fetchRoles();
      setRoles(data);
    } catch (error) {
      setError(error.message);
      toast({
        title: "Error",
        description: "something went wrong",
        status: "error",
        isClosable: true,
        duration: 9000,
      });
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log(formData);
      await updateUserDetailsById(id, formData);
      toast({
        title: "Success",
        description: "User updated!",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      console.log(error);
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }

    setLoading(false);
  };

  const getUserDetails = async () => {
    try {
      let data = await fetchUserDetailsById(id);
      setFormData({ ...data, role: data?.roleId });
    } catch (error) {
      console.log(error);
      setError(error.message);
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getAllRoles();
    getUserDetails();
  }, []);

  if (error == "Unauthorized user") {
    return <Unauthorized />;
  }

  return (
    <Box px={6} py={8}>
      <BreadCrumbMaker
        items={[
          // { link: "/", title: "Dashboard" },
          { link: "/settings", title: "Access Control" },
          { link: "/settings/user/create", title: "Edit User", on: true },
        ]}
      />
      <Box bg={"white"} px={6} py={8} borderRadius={"2xl"}>
        <Flex justifyContent={"space-between"} fontSize={"0.875rem"} letterSpacing={0} >
          <Heading fontSize="lg" mb={4} color={"#1A202C"}>
            Update User
          </Heading>
          <Text color={"#90A3BF"}>Step 1 of 1</Text>
        </Flex>
        <form onSubmit={handleSubmit}>
          <Grid
            templateColumns={{
              base: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(3,1fr)",
            }}
            gap={4}
            mb={6}
          >
            <FormControl  >
              <FormLabel fontSize="1rem" color={"#1A202C"} htmlFor={"firstName"} my={2}>{"First Name"}</FormLabel>
              <Input
                type="text"
                variant={"filled"}
                value={formData.firstName}
                name="firstName"
                placeholder="Enter First Name"
                borderRadius={"lg"}
                // borderColor={"gray.500"}
                onChange={handleChange}
                required
                h={"56px"}
              />
            </FormControl>
            <FormControl  >
              <FormLabel fontSize="1rem" color={"#1A202C"} htmlFor={"lastName"} my={2}>{"Last Name"}</FormLabel>
              <Input
                type="text"
                variant={"filled"}
                value={formData.lastName}
                name="lastName"
                placeholder="Enter Last Name"
                borderRadius={"lg"}
                // borderColor={"gray.500"}
                onChange={handleChange}
                required
                h={"56px"}
              />
            </FormControl>
            <FormControl  >
              <FormLabel fontSize="1rem" color={"#1A202C"} htmlFor={"email"} my={2}>{"Email Id"}</FormLabel>
              <Input
                type="email"
                variant={"filled"}
                value={formData.email}
                name="email"
                placeholder="Enter Email Address"
                borderRadius={"lg"}
                // borderColor={"gray.500"}
                onChange={handleChange}
                required
                h={"56px"}
                fontSize={"sm"}
                _placeholder={{ fontSize: "10px", lineHeight: "short", color: "gray.400" }}
              />
            </FormControl>

            <FormControl  >
              <FormLabel fontSize="1rem" color={"#1A202C"} htmlFor={"phoneNumber"} my={2}>{"Phone Number"}</FormLabel>
              <Input
                type="tel"
                variant={"filled"}
                value={formData.phoneNumber}
                name="phoneNumber"
                placeholder="Enter Phone Number"
                borderRadius={"lg"}
                // borderColor={"gray.500"}
                onChange={handleChange}
                required
                h={"56px"}
              />
            </FormControl>
            <FormControl  >
              <FormLabel my={2}>Gender</FormLabel>
              <InputGroup>
                <InputLeftAddon
                  pointerEvents="none"
                  h="56px"
                  borderRightRadius="0" // Removes right radius to connect with Select
                >
                  <Icon as={FaUser} color="gray.400" />
                </InputLeftAddon>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  placeholder="Select Gender"
                  _placeholder={{ fontSize: "sm", color: "#90A3BF" }}
                  variant="filled"
                  borderLeftRadius="0" // Removes left radius to connect with Addon
                  borderRightRadius="lg" // Keep rounded outer corner
                  _focus={{
                    borderColor: "blue.500",
                    boxShadow: "0 0 0 1px blue.500",
                  }}
                  w="100%"
                  h="56px"
                >
                  <option value="">Select Gender</option>
                  {genders?.map((gender, index) => (
                    <option key={index} value={gender?.id}>
                      {gender?.Name}
                    </option>
                  ))}
                </Select>
              </InputGroup>

            </FormControl>
            <FormControl >
              <FormLabel my={2}>Role</FormLabel>
              <InputGroup>
                <InputLeftAddon
                  pointerEvents="none"
                  h="56px"
                  borderRightRadius="0" // Remove right border radius
                >
                  <Icon as={FaUser} color="gray.400" />
                </InputLeftAddon>
                <Select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  placeholder="Select Role"
                  _placeholder={{ fontSize: "sm", color: "#90A3BF" }}
                  variant="filled"
                  borderLeftRadius="0" // Remove left border radius
                  borderRightRadius="lg" // Keep right radius
                  _focus={{
                    borderColor: "blue.500",
                    boxShadow: "0 0 0 1px blue.500",
                  }}
                  w="100%"
                  h="56px"
                >
                  <option value="">Select Role</option>
                  {roles?.map((role, index) => (
                    <option key={index} value={role?._id}>
                      {role?.roleName}
                    </option>
                  ))}
                </Select>
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="1rem" color="#1A202C" htmlFor="password" my={2}>
                Password
              </FormLabel>
              <InputGroup>
                <Input
                  type={show ? "text" : "password"}
                  variant="filled"
                  value={formData.password}
                  name="password"
                  placeholder="Enter Password"
                  borderLeftRadius="lg"     // Keep left rounded
                  borderRightRadius="0"     // Remove right radius to connect with addon
                  onChange={handleChange}
                  h="56px"
                  required
                />
                <InputRightAddon
                  borderLeftRadius="0"     // Remove left radius to connect with input
                  borderRightRadius="lg"   // Keep right rounded
                  h="56px"
                >
                  <Button variant="ghost" onClick={() => setShow(!show)} px={2}>
                    {show ? <FaRegEyeSlash /> : <FaRegEye />}
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </FormControl>

          </Grid>
          {/* <FormControl mb={4}>
          <FormLabel>Email</FormLabel>
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </FormControl>
        <FormControl mb={4}>
          <FormLabel>New Password</FormLabel>
          <InputGroup>
            <Input
              type={show ? "text" : "password"}
              name="password"
              value={""}
              onChange={handleChange}
            />
            <InputRightAddon>
              <Button variant="ghost" onClick={() => setShow(!show)}>
                {show ? <FaRegEyeSlash /> : <FaRegEye />}
              </Button>
            </InputRightAddon>
          </InputGroup>
        </FormControl>
        <FormControl mb={4}>
          <FormLabel>Name</FormLabel>
          <Input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </FormControl>
        <FormControl mb={4}>
          <FormLabel>Role</FormLabel>
          <Select
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
          >
            <option value="">Select Role</option>
            {roles?.map((role, index) => (
              <option key={index} value={role?._id}>
                {role?.roleName}
              </option>
            ))}
          </Select>
        </FormControl> */}
          <Button colorScheme="blue" mt={4} type="submit" px={10} isLoading={loading}>
            Update
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default EditUser;
